import { getUserInfo } from "@/apis/userInfo"
import router from "@/router"
const state = {
  // 用户信息
  userInfo: localStorage.getItem("userInfo") || null,
  // 用户token
  token: localStorage.getItem("token") || null,
  // 是否已登录
  isLoggedIn: localStorage.getItem("isLoggedIn") || false,
  isLoggedDialogVisible: false,
  isRegisterDialogVisible: false,
  isInviteRegisterDialogVisible: false,
  // 是否是登录后第一次进入首页
  isFirstEnterHome: localStorage.getItem("isFirstEnterHome") || false,
  isNewRegister: false,
  couponAmount: 0,

  isShowPasswordDialog: localStorage.getItem("isShowPasswordDialog") || "true",
  isShowReviewDialog: localStorage.getItem("isShowReviewDialog") || "true",
  // 已处理的邀请码列表，用于避免重复弹出注册框（内存存储，页面刷新后清空）
  processedInviteCodes: [],
}

const mutations = {
  // 设置用户信息
  SET_USER_INFO(state, userInfo) {
    state.userInfo = JSON.stringify(userInfo)
    // 同步到localStorage
    if (userInfo) {
      localStorage.setItem("userInfo", JSON.stringify(userInfo))
    } else {
      localStorage.removeItem("userInfo")
    }
  },

  // 设置token
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem("token", token)
    } else {
      localStorage.removeItem("token")
    }
  },

  // 设置登录状态
  SET_LOGIN_STATUS(state, status) {
    state.isLoggedIn = status
    // 同步到localStorage
    if (status) {
      localStorage.setItem("isLoggedIn", "true")
    } else {
      localStorage.removeItem("isLoggedIn")
    }
  },

  // 清除用户信息
  CLEAR_USER_INFO(state) {
    state.userInfo = null
    state.token = null
    state.isLoggedIn = false
    state.isNewRegister = false
    state.couponAmount = 0
    state.isShowPasswordDialog = "true"
    state.isShowReviewDialog = "true"
    // 清除localStorage
    localStorage.removeItem("userInfo")
    localStorage.removeItem("token")
    localStorage.removeItem("isLoggedIn")
    localStorage.removeItem("isShowPasswordDialog")
    localStorage.removeItem("isShowReviewDialog")
    localStorage.removeItem("isFirstEnterHome")
    localStorage.removeItem("yoyotravel_recentSearches_SIM")
    localStorage.removeItem("yoyotravel_recentSearches_eSIM")
    console.log("清除用户信息 :>> ", state)
  },
  SET_LOGIN_DIALOG_VISIBLE(state, status) {
    state.isLoggedDialogVisible = status
  },
  SET_REGISTER_DIALOG_VISIBLE(state, status) {
    state.isRegisterDialogVisible = status
  },
  SET_INVITE_REGISTER_DIALOG_VISIBLE(state, status) {
    console.log('status :>> ', status);
    state.isInviteRegisterDialogVisible = status
  },
  SET_IS_NEW_REGISTER(state, { newRegister, couponAmount }) {
    state.isNewRegister = newRegister
    state.couponAmount = couponAmount
  },
  SET_IS_SHOW_PASSWORD_DIALOG(state, status) {
    state.isShowPasswordDialog = status
    localStorage.setItem("isShowPasswordDialog", status)
  },
  SET_IS_SHOW_REVIEW_DIALOG(state, status) {
    state.isShowReviewDialog = status
    localStorage.setItem("isShowReviewDialog", status)
  },
  SET_IS_FIRST_ENTER_HOME(state, status) {
    state.isFirstEnterHome = status
    localStorage.setItem("isFirstEnterHome", status)
  },
  // 记录已处理的邀请码
  ADD_PROCESSED_INVITE_CODE(state, code) {
    if (!state.processedInviteCodes.includes(code)) {
      state.processedInviteCodes.push(code)
    }
  },
}

const actions = {
  // 获取用户信息
  async fetchUserInfo({ commit, state }) {
    try {
      if (!state.isLoggedIn) {
        return
      }
      const response = await getUserInfo()
      commit("SET_USER_INFO", response.data)
      return response.data
    } catch (error) {
      console.error("刷新用户信息失败:", error)
      throw error
    }
  },

  // 登录
  async login({ commit, dispatch, rootState }, { token, userInfo, newRegister, couponAmount }) {
    try {
      commit("SET_IS_NEW_REGISTER", { newRegister, couponAmount })
      commit("SET_TOKEN", token)

      const email = userInfo.email || ""
      console.log("email :>> ", email)
      if (userInfo) {
        commit("SET_USER_INFO", userInfo)
      }
      commit("SET_LOGIN_STATUS", true)
      userInfo = await dispatch("fetchUserInfo")
      console.log('userInfo :>> ', userInfo);
      commit("SET_USER_INFO", { ...userInfo, email })
      const route = rootState.route
      // console.log('route :>> ', route);
      // if (route.name !== "home") {
      //   window.history.replaceState(null, null, window.location.origin + "/#/home")
        // router.replace(route.fullPath)
        window.location.reload()
      // }
      return userInfo
    } catch (error) {}
  },

  // 更新用户信息
  updateUserInfo({ commit }, userInfo) {
    commit("SET_USER_INFO", userInfo)
  },
}

const getters = {
  // 获取用户信息
  userInfo: (state) => {
    const userInfo = state.userInfo || localStorage.getItem("userInfo")
    // console.log('getters---userInfo :>> ', JSON.parse(userInfo));

    return JSON.parse(userInfo) || {}
  },

  // 获取token
  token: (state) => state.token || localStorage.getItem("token"),

  // 是否已登录
  isLoggedIn: (state) => state.isLoggedIn || localStorage.getItem("isLoggedIn"),

  // 是否显示登录弹框
  isLoggedDialogVisible: (state) => state.isLoggedDialogVisible,
  // 是否显示注册弹框
  isRegisterDialogVisible: (state) => state.isRegisterDialogVisible,

  // 是否显示邀请注册弹框
  isInviteRegisterDialogVisible: (state) => state.isInviteRegisterDialogVisible,

  
  isFirstEnterHome: (state) => state.isFirstEnterHome,

  // 是否是新注册
  isNewRegister: (state) => state.isNewRegister,

  // 获取新人优惠券金额
  couponAmount: (state) => state.couponAmount,
  isShowPasswordDialog: (state) => state.isShowPasswordDialog,
  isShowReviewDialog: (state) => state.isShowReviewDialog,
  // 获取已处理的邀请码列表
  processedInviteCodes: (state) => state.processedInviteCodes,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
